// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__B8i8l","consentsList":"PatientConsents_consentsList__TuQxw","consentsListEmpty":"PatientConsents_consentsListEmpty__2z0DJ"};